const GOOGLE_MAPS_LOCALE_MAP = {
  'zh-cn': { language: 'zh-CN', region: 'CN' },
  'en-us': { language: 'en', region: 'US' },
  de: { language: 'de', region: 'DE' }
};

const DEFAULT_LOCALE = GOOGLE_MAPS_LOCALE_MAP['en-us'];

export function getGoogleMapsLocale(lang) {
  return GOOGLE_MAPS_LOCALE_MAP[lang] || DEFAULT_LOCALE;
}

export function getGoogleMapsLanguage(lang) {
  return getGoogleMapsLocale(lang).language;
}

export function buildGoogleMapsScriptUrl({ apiKey, lang }) {
  const { language, region } = getGoogleMapsLocale(lang);

  return `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&sensor=false&language=${language}&region=${region}`;
}
